var React = require('react');

function ImageSize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.7,0H1.3C0.6,0,0,0.6,0,1.3v13.3C0,15.4,0.6,16,1.3,16h13.3c0.7,0,1.3-0.6,1.3-1.3V1.3C16,0.6,15.4,0,14.7,0z M14,12H2V2\n\th12V12z M5.2,7.8C4.8,8.3,4.8,9.2,5.4,9.7c0.5,0.5,1.3,0.5,1.9,0.1c0.3,0.7,1,1,1.7,0.8c0.3-0.1,0.5-0.2,0.6-0.4\n\tC9.9,9.9,10.1,9.5,10,9c0.7,0.1,1.4-0.3,1.6-1.1c0.2-0.7-0.2-1.4-0.8-1.7c0.4-0.6,0.4-1.4-0.1-1.9l0,0c0,0,0,0,0,0\n\tc-0.5-0.5-1.3-0.5-1.9-0.1c-0.3-0.7-1-1-1.7-0.8C6.3,3.6,5.9,4.3,6,5C5.3,4.9,4.6,5.4,4.4,6.1C4.2,6.8,4.6,7.5,5.2,7.8z M8,5.7\n\tc0.7,0,1.3,0.6,1.3,1.3S8.7,8.3,8,8.3S6.7,7.7,6.7,7S7.3,5.7,8,5.7z","fill":"currentColor"}));
}

ImageSize.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ImageSize;

ImageSize.default = ImageSize;
